module.exports = __webpack_public_path__ + "static/img/15.329aae0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/15.png
// module id = 3mbl
// module chunks = 0